import { render, staticRenderFns } from "./jobfairCompany.vue?vue&type=template&id=8f648f82&scoped=true"
import script from "./jobfairCompany.vue?vue&type=script&lang=js"
export * from "./jobfairCompany.vue?vue&type=script&lang=js"
import style0 from "./jobfairCompany.vue?vue&type=style&index=0&id=8f648f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f648f82",
  null
  
)

export default component.exports